export default __webpack_public_path__ + "_/images/app/app-gif-ru-a34aa4f7e4adfacd22f1f897ff61fb998891c72241c2318426e6a3d4484287b2.gif";